import { IAppState, IRootState } from '@/@types'
import { GetterTree } from 'vuex'

const getters: GetterTree<IAppState, IRootState> = {
  showScheduledBanner: (state, getters, rootState) => {
    return (
      !state.scheduledMaintenanceClosed &&
      rootState.featureFlags.flags.maintenanceScheduled !== ''
    )
  },
}

export default getters
